module.exports = __webpack_public_path__ + "media/images/category/dummy/bottoms04-925e4b749f845fae3cb5b21f718bdd70.jpg";